module.exports = __webpack_public_path__ + "img/喜报5.b63c43ff.jpg";